module.exports = __webpack_public_path__ + "img/qq.6ad40b43.png";